module.exports = __webpack_public_path__ + "img/Contact-Salessheet.svg";


//////////////////
// WEBPACK FOOTER
// ./img/Contact-Salessheet.svg
// module id = 243
// module chunks = 0